import { Component } from '@angular/core';

@Component({
  selector: 'sp-default-footer',
  templateUrl: './default-footer.component.html',
  standalone: false
})
export class DefaultFooterComponent {

  year: number;

  constructor() {
    this.year = (new Date()).getFullYear();
  }
}
